<template>
    <div class="pages">
        <div class="pages-section">
            <h4>今日数据</h4>
            <div class="pages-section--body">
                <el-row :gutter="10">
                    <el-col :lg="4" :sm="8" :md="6">
                        <div class="pages-section--unit">
                            <p class="pages-section--text">今日充值金额</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日提款金额</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日收益总额</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日注册人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日实名人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日充值人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col :lg="4" :sm="8" :md="6">
                        <div class="pages-section--unit">
                            <p class="pages-section--text">今日订阅金额</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日订阅订单数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日订阅人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日抽奖红包</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日签到人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日上分</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">今日首存人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </div>
        <div class="pages-section">
            <h4>总计</h4>
            <div class="pages-section--body">
                <el-row :gutter="10">
                    <el-col :lg="4" :sm="8" :md="6">
                        <div class="pages-section--unit">
                            <p class="pages-section--text">总充值</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总提款</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总收益</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总注册人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总实名人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总充值人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col :lg="4" :sm="8" :md="6">
                        <div class="pages-section--unit">
                            <p class="pages-section--text">总订阅金额</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总订阅订单数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总订阅人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总抽奖红包</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总签到人数</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总上分</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                    <el-col  :lg="4" :sm="8" :md="6">
                         <div class="pages-section--unit">
                            <p class="pages-section--text">总余额</p>
                            <p class="pages-section--data">123</p>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </div>
    </div>
</template>

<script setup></script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.pages {
    width: calc(100% - 24px);;
    display: block;
    background-color: #f1f1f1;
    padding: 0;
    &-section {
        margin-bottom: 10px;
        background-color: #fff;
        width: 100%;
        padding: 10px;

        h4 {
            font-size: 16px;
            line-height: 32px;
            border-bottom: 1px solid #eee;
            text-align: left;
            font-weight: 600;
            font-size: 15px;
        }

        &--body {
            padding: 8px 10px;
            display: flex;
            gap: 8px;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            padding: 10px 0;
        }
        &--unit {
            background-color: #f8f8f8;
            border-radius: 4px;
            transition: all .25s;
            cursor: pointer;
            padding: 15px 10px;
            &:hover {
                background-color: #cfcfcf;
            }
            text-align: center;
            font-size: 14px;
            line-height: 1.8;
            margin-bottom: 10px;
        }
        &--data {
            color: #009688;
        }
        ::v-deep .el-row {
            width: 100%;
        }

        ::v-deep .el-col {
        }

    }
}
</style>